export class PublicQuantityChangeFailureEvent {
  public constructor(
    private readonly data: {
      reasons: string[];
    },
  ) {}

  public get reasons(): string[] {
    return this.data.reasons;
  }

  public get multilineReasons(): string {
    return this.data.reasons.join('\n');
  }
}
